import { keyBy } from 'lodash';

import {
  GET_LIST_INFORMATION,
  GET_LIST_INFORMATION_FAILED,
  GET_LIST_INFORMATION_SUCCESS,
} from "../actions/informationManagement.action";

const INITIAL_STATE = {
  information: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function informationReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LIST_INFORMATION:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_LIST_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        information: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_LIST_INFORMATION_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
